import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const COLORI = {
  accesso:        { sfondo:'#dcfce7', testo:'#15803d', etichetta:'Accesso' },
  accesso_negato: { sfondo:'#fee2e2', testo:'#b91c1c', etichetta:'Accesso negato' },
  creazione:      { sfondo:'#dbeafe', testo:'#1d4ed8', etichetta:'Creazione' },
  modifica:       { sfondo:'#fef9c3', testo:'#854d0e', etichetta:'Modifica' },
  eliminazione:   { sfondo:'#fee2e2', testo:'#b91c1c', etichetta:'Eliminazione' },
};
const stile = a => COLORI[a] || { sfondo:'#f1f5f9', testo:'#475569', etichetta:a };

export default function LogPage() {
  const { isAdmin } = useAuth();

  const [righe, setRighe]       = useState([]);
  const [riepilogo, setRiep]    = useState([]);
  const [falliti, setFalliti]   = useState(0);
  const [totale, setTotale]     = useState(0);
  const [pagine, setPagine]     = useState(1);
  const [pagina, setPagina]     = useState(1);
  const [giorni, setGiorni]     = useState(7);
  const [azione, setAzione]     = useState('');
  const [utente, setUtente]     = useState('');
  const [loading, setLoading]   = useState(true);

  const carica = useCallback(() => {
    setLoading(true);
    const q = new URLSearchParams({ giorni, pagina });
    if (azione) q.set('azione', azione);
    if (utente) q.set('utente', utente);
    api.get(`/log?${q}`)
      .then(r => {
        setRighe(r.data?.data || []);
        setRiep(r.data?.riepilogo || []);
        setFalliti(r.data?.accessiFalliti || 0);
        setTotale(r.data?.totale || 0);
        setPagine(r.data?.pagine || 1);
      })
      .catch(() => setRighe([]))
      .finally(() => setLoading(false));
  }, [giorni, azione, utente, pagina]);

  useEffect(() => { carica(); }, [carica]);
  useEffect(() => { setPagina(1); }, [giorni, azione, utente]);

  if (!isAdmin) {
    return (
      <div className="page-content">
        <p style={{ color:'#6b7280' }}>Questa sezione è riservata agli amministratori.</p>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:14, flexWrap:'wrap' }}>
        <h2 style={{ margin:0, fontSize:18 }}>📋 Registro attività</h2>
        <span style={{ fontSize:13, color:'#9ca3af' }}>{totale} registrazioni</span>

        <select className="form-control" style={{ maxWidth:150, marginLeft:'auto' }}
          value={giorni} onChange={e=>setGiorni(Number(e.target.value))}>
          <option value={1}>Ultime 24 ore</option>
          <option value={7}>Ultimi 7 giorni</option>
          <option value={30}>Ultimi 30 giorni</option>
          <option value={90}>Ultimi 90 giorni</option>
        </select>

        <select className="form-control" style={{ maxWidth:170 }}
          value={azione} onChange={e=>setAzione(e.target.value)}>
          <option value="">Tutte le attività</option>
          <option value="accesso">Accessi</option>
          <option value="accesso_negato">Accessi negati</option>
          <option value="creazione">Creazioni</option>
          <option value="modifica">Modifiche</option>
          <option value="eliminazione">Eliminazioni</option>
        </select>

        <input className="form-control" style={{ maxWidth:160 }} placeholder="🔍 Utente..."
          value={utente} onChange={e=>setUtente(e.target.value)} />
      </div>

      {falliti > 0 && (
        <div style={{ padding:'10px 14px', background:'#fef2f2', color:'#b91c1c',
                      borderRadius:8, fontSize:13, marginBottom:12, borderLeft:'4px solid #dc2626' }}>
          <strong>{falliti}</strong> {falliti === 1 ? 'tentativo di accesso non riuscito' : 'tentativi di accesso non riusciti'} nel periodo selezionato.
        </div>
      )}

      {riepilogo.length > 0 && (
        <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
          {riepilogo.map(r => {
            const s = stile(r.azione);
            return (
              <div key={r.azione} onClick={()=>setAzione(azione === r.azione ? '' : r.azione)}
                style={{ padding:'8px 14px', borderRadius:8, cursor:'pointer',
                         background:s.sfondo, color:s.testo,
                         border: azione === r.azione ? `2px solid ${s.testo}` : '2px solid transparent' }}>
                <div style={{ fontSize:20, fontWeight:700 }}>{r.quanti}</div>
                <div style={{ fontSize:11 }}>{s.etichetta}</div>
              </div>
            );
          })}
        </div>
      )}

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{ padding:0 }}>
          <div className="table-wrap">
            <table className="q-table">
              <thead>
                <tr>
                  <th>Data e ora</th>
                  <th>Utente</th>
                  <th>Attività</th>
                  <th>Oggetto</th>
                  <th>Dettaglio</th>
                  <th>Provenienza</th>
                </tr>
              </thead>
              <tbody>
                {righe.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign:'center', color:'#9ca3af', padding:32 }}>
                    Nessuna registrazione nel periodo
                  </td></tr>
                )}
                {righe.map(r => {
                  const s = stile(r.azione);
                  return (
                    <tr key={r.id}>
                      <td style={{ fontSize:12, whiteSpace:'nowrap' }}>{r.quando}</td>
                      <td style={{ fontWeight:600, fontSize:12 }}>{r.username || '—'}</td>
                      <td>
                        <span className="badge" style={{ background:s.sfondo, color:s.testo, fontSize:10 }}>
                          {s.etichetta}
                        </span>
                      </td>
                      <td style={{ fontSize:12 }}>
                        {r.oggetto || '—'}
                        {r.oggetto_id && <span style={{ color:'#9ca3af' }}> #{r.oggetto_id}</span>}
                      </td>
                      <td style={{ fontSize:12, color:'#6b7280', maxWidth:260, overflow:'hidden',
                                   textOverflow:'ellipsis', whiteSpace:'nowrap' }}
                          title={r.descrizione || ''}>
                        {r.descrizione || '—'}
                        {r.esito && r.esito !== 'ok' && (
                          <span style={{ color:'#dc2626', marginLeft:6 }}>({r.esito})</span>
                        )}
                      </td>
                      <td style={{ fontSize:11, color:'#9ca3af' }} title={r.dispositivo || ''}>
                        {r.indirizzo_ip || '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {pagine > 1 && (
        <div style={{ display:'flex', gap:8, justifyContent:'center', marginTop:14 }}>
          <button className="btn btn-secondary btn-sm" disabled={pagina <= 1}
            onClick={()=>setPagina(pagina-1)}>⬅</button>
          <span style={{ alignSelf:'center', fontSize:13 }}>{pagina}/{pagine}</span>
          <button className="btn btn-secondary btn-sm" disabled={pagina >= pagine}
            onClick={()=>setPagina(pagina+1)}>➡</button>
        </div>
      )}

      <p style={{ fontSize:11, color:'#9ca3af', marginTop:16 }}>
        Le registrazioni sono conservate per 90 giorni e servono unicamente alla sicurezza del sistema.
      </p>
    </div>
  );
}
